<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="'Configuración empresas'" [description]="" [awesomeIcon]="'cog'">
    <form class="form-horizontal ng-untouched ng-pristine ng-valid" (ngSubmit)="onSubmit(formCompanyconfig)"
      #formCompanyconfig="ngForm" novalidate="">
      <div class="row">
        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <legend>Bolsa de vacaciones</legend>
            <div class="col-12">
              <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="model && model.CodigoEmpresa" name="codigoEmpresa"
                (selectedValueChange)="companySelectedChanged($event)"  [required]="true" [disabled]="model && !model.isNew">
              </app-company-selector>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <legend>Convenios activos</legend>
            <div class="col-12">
              <app-mat-select-filtered [items]="agreements" [valueColumn]="'id'"
                [descriptionColumns]="['description']" [multiple]="true" [placeHolder]="'Convenios'" [(ngModel)] = "selectedAgreements"
                name="selectedAgreements">
              </app-mat-select-filtered>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <legend>Notificaciones</legend>
            <div class="col-12">
              <app-mat-select-filtered [items]="users" valueColumn="Id"
                [descriptionColumns]="['Name', 'Surname']" [multiple]="true" [placeHolder]="'Usuarios'" [(ngModel)] = "selectedUsers"
                name="selectedUsers">
              </app-mat-select-filtered>
            </div>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <label class="col-md-3"></label>
        <div class="col-md-9">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-primary float-right" type="submit"
              [disabled]="!formCompanyconfig.valid">Guardar</button>
            <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </form>
  </app-generic-panel>

  <app-generic-panel [title]="'Configuración convenios'" [description]="" [awesomeIcon]="'book'" *ngIf="model && !model.isNew">
    <form class="form-horizontal ng-untouched ng-pristine ng-valid"
      #formConfigAgreements="ngForm" novalidate="" (ngSubmit)="onSubmitAgreementsConfig()">

      <div class="row" style="margin-bottom: 20px;">
        <div class="col-12">
          <div class="row">
            <div class="col-md col-lg col-xl">
              <app-mat-select-filtered [items]="companySelectedAgreements" [valueColumn]="'Id'"
                [descriptionColumns]="['Descripcion']" [multiple]="false" [placeHolder]="'Convenios'"
                name="companySelectedAgreementValue" [emptyOption]="true" [ngModel]="companySelectedAgreementValue" (ngModelChange)="onSelectedAgreementsChange($event)">
              </app-mat-select-filtered>
            </div>
          </div>
        </div>
      </div>

      <app-convenios-list [companyCode]="model && model.CodigoEmpresa" [convenioEmpresa]="companySelectedAgreement" [esEditable]="calculosBolsaVacacionesActivo" (onClonate)="onClonatedItem($event)" (onGridUpdated)="onCalculosConvenioGridUpdated()">
      </app-convenios-list>

      <!-- Botonera -->
      <div class="row">
        <label class="col-md-3"></label>
        <div class="col-md-9">
          <div class="form-group form-button">
            <!-- <button class="btn btn-fill btn-primary float-right" type="submit"
              >Guardar</button> -->
          </div>
        </div>
      </div>
    </form>
  </app-generic-panel>

</app-generic-container>
